import { app } from '../../../../../app';
import { Controller } from './remove-remote-app.controller';

app.component('companyManageApplicationRemoteAppRemove', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./remove-remote-app.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/remote-app-access/remove/remove-remote-app.component.js